module.exports = __webpack_public_path__ + "static/media/large-pickup.a14710e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vehicles/large-pickup.png
// module id = 657
// module chunks = 27